import {ValueObject} from '@s-ui/domain'

import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'
import {FilterModelSearchValueObject} from './FilterModelSearchValueObject.js'
import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterVehicleSearchValueObject extends ValueObject {
  #make
  #makeId
  #model
  #modelId
  #version

  constructor({make, makeId, model, modelId, version}) {
    super()
    this.#make = make
    this.#makeId = makeId
    this.#model = model
    this.#modelId = modelId
    this.#version = version
  }

  static create({make, makeId, model, modelId, version}) {
    return new FilterVehicleSearchValueObject({
      make: FilterStringSearchValueObject.create(make),
      makeId: FilterIdSearchValueObject.create(makeId),
      model: FilterModelSearchValueObject.create(model),
      modelId: FilterIdSearchValueObject.create(modelId),
      version: FilterStringSearchValueObject.create(version)
    })
  }

  static createWithDefaultValue({config, vehicle}) {
    const {DEFAULT_VEHICLE_SEARCH} = config.get('searchFilters')

    return new FilterVehicleSearchValueObject({
      make: FilterStringSearchValueObject.create({string: vehicle.make ?? DEFAULT_VEHICLE_SEARCH.make}),
      makeId: FilterIdSearchValueObject.create({id: vehicle.makeId ?? DEFAULT_VEHICLE_SEARCH.makeId}),
      model: FilterStringSearchValueObject.create({
        config,
        string: vehicle.model ?? DEFAULT_VEHICLE_SEARCH.model
      }),
      modelId: FilterIdSearchValueObject.create({id: vehicle.modelId ?? DEFAULT_VEHICLE_SEARCH.modelId}),
      version: FilterStringSearchValueObject.create({
        config,
        string: vehicle.version ?? DEFAULT_VEHICLE_SEARCH.version
      })
    })
  }

  static createFromGroupedModel({make, makeId, model, version}) {
    return new FilterVehicleSearchValueObject({
      make: FilterStringSearchValueObject.create({string: make}),
      makeId: FilterIdSearchValueObject.create({id: makeId}),
      model: FilterStringSearchValueObject.create({string: model.name}),
      modelId: FilterIdSearchValueObject.create({id: model.id}),
      version: FilterStringSearchValueObject.create({string: version})
    })
  }

  get valueWithGroupedModel() {
    return {
      make: this.#make.value,
      makeId: this.#makeId.value,
      model: {id: this.#modelId.value, name: this.#model.value},
      version: this.#version.value
    }
  }

  get value() {
    return {
      make: this.#make.value,
      makeId: this.#makeId.value,
      model: this.#model.value,
      modelId: this.#modelId.value,
      version: this.#version.value
    }
  }

  toJSON() {
    return {
      make: this.#make.toJSON(),
      makeId: this.#makeId.toJSON(),
      model: this.#model.toJSON(),
      modelId: this.#modelId.toJSON(),
      version: this.#version.toJSON()
    }
  }
}
